import { useEffect } from 'react'
import { Routes, Route, Navigate, useLocation } from 'react-router-dom'
import Navbar from './components/Navbar'
import About from './components/About'
import Experience from './components/Experience'
import FocusAreas from './components/FocusAreas'
import Projects from './components/Projects'
import Impact from './components/Impact'
import Principles from './components/Principles'
import Contact from './components/Contact'
import ProjectDetail from './components/ProjectDetail'
import Footer from './components/Footer'
import CVModal from './components/CVModal'
import BackToTop from './components/BackToTop'
import {
  initLenis,
  destroyLenis,
  initSlideReveals,
  prefersReducedMotion,
  scrollToSection,
  scrollToTop,
} from './lib/motion'

const Home: React.FC = () => (
  <main id="main-content">
    <About />
    <Experience />
    <FocusAreas />
    <Projects />
    <Impact />
    <Principles />
    <Contact />
  </main>
)

const App: React.FC = () => {
  const location = useLocation()

  useEffect(() => {
    if (prefersReducedMotion()) return
    initLenis()
    return () => destroyLenis()
  }, [])

  useEffect(() => {
    scrollToTop()

    const target = location.state?.scrollTo as string | undefined
    const raf = target
      ? window.requestAnimationFrame(() => scrollToSection(`#${target}`))
      : 0

    let cleanupReveals: (() => void) | undefined
    if (!prefersReducedMotion()) cleanupReveals = initSlideReveals()

    return () => {
      if (raf) window.cancelAnimationFrame(raf)
      cleanupReveals?.()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname])

  return (
    <div className="min-h-screen bg-white dark:bg-neutral-950 text-neutral-900 dark:text-neutral-100">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[100] focus:rounded-lg focus:bg-neutral-900 focus:px-4 focus:py-2 focus:text-sm focus:font-medium focus:text-white dark:focus:bg-white dark:focus:text-neutral-900"
      >
        Skip to content
      </a>
      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/projects/:projectId" element={<ProjectDetail />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      <Footer />
      <CVModal />
      <BackToTop />
    </div>
  )
}

export default App